angular.module 'zc.commonApi'

.factory "MongoConversion", ($q, FacadeV2) ->


  class MongoConversion

    @find: (query, options = {}) ->
      $q (resolve, reject) ->
        query ||= {}

        unless query.apikey
          return reject "No apikey"

        FacadeV2.request "/apikeys/#{query.apikey}/conversions",
          params:
            match: query
            sort: options.sort
            fields: options.fields
            limit: options.limit || 1000
          cache: false
        .then (res) ->
          if res.status != 200 || res.data.error
            reject res.data.error
          else
            resolve res.data

  MongoConversion



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/mongo_conversion.service.coffee